import { render, staticRenderFns } from "./ProtocoloParte.vue?vue&type=template&id=1fe89c3e&scoped=true&"
import script from "./ProtocoloParte.vue?vue&type=script&lang=js&"
export * from "./ProtocoloParte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe89c3e",
  null
  
)

export default component.exports